module.exports = __webpack_public_path__ + "img/7 Tips for Contributing to Your HSA Infographic.1587a4e5.png";